import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './pages/app'
import UserRecordingsPage from './pages/user-recordings'
import { AppProvider } from './components'
import { ProgramSearchPage } from './pages/program-search'
import { ChannelPage } from './pages/channel-page'
const language = window.ISites.WegLot?.GetCurrentLanguage() || "PT"

const PageRouter = () => (
  <div className="tv-guide">
    <AppProvider>
      <BrowserRouter
        basename={
          language === 'EN'
            ? import.meta.env.VITE_APP_BASE_URL_EN
            : import.meta.env.VITE_APP_BASE_URL
        }
      >
        <Routes>
          <Route path="/" element={<App />} />
          <Route
            path={language === 'EN' ? '/recordings' : '/gravacoes-agendadas'}
            element={<UserRecordingsPage />}
          />
          <Route
            path={language === 'EN' ? '/search-results' : '/pesquisa'}
            element={<ProgramSearchPage />}
          />
          <Route
            path={language === 'EN' ? '/channel' : '/canal'}
            element={<ChannelPage />}
          >
            <Route
              index
              path={language === 'EN' ? '/channel/:id' : '/canal/:id'}
              element={<ChannelPage />}
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </AppProvider>
  </div>
)

export default PageRouter
